// extracted by mini-css-extract-plugin
module.exports = {"box":"Illegal_style_box__1xAyE","rule":"Illegal_style_rule__1hTOk"};